var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showButton)?_c('button',{staticClass:"btn btn-outline-primary btn-sm d-flex align-items-center",attrs:{"type":"button"},on:{"click":_vm.toggleDialer}},[_c('span',{staticClass:"mr-50"},[_vm._v("Phone")]),_c('span',{staticClass:"erp-phone-dot",class:{
      'erp-phone-dot--ready': _vm.isRegistered,
      'erp-phone-dot--busy': _vm.hasActiveCall || _vm.hasIncomingCall,
      'erp-phone-dot--error': !_vm.isRegistered,
    }})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }